import React from "react";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";
import HomeLogoLink from "../../Components/Common/HomeLogoLink";

const contactDetails = [
    {
        icon: "mdi-email-outline",
        label: "Email",
        value: "support@kioskqr.com",
        href: "mailto:support@kioskqr.com",
    },
    {
        icon: "mdi-clock-outline",
        label: "Thời gian hỗ trợ",
        value: "24/24",
    },
    {
        icon: "mdi-phone-outline",
        label: "Hotline",
        value: "0858686846",
        href: "tel:0858686846",
    },
    {
        icon: "mdi-web",
        label: "Website",
        value: "kioskqr.com",
        href: "https://kioskqr.com",
    },
];

const ContactPage = () => (
    <React.Fragment>
        <div className="header-area" id="headerArea">
            <div className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                <HomeLogoLink className="me-2" />
                <div className="page-heading">
                    <h6 className="mb-0">Liên hệ</h6>
                </div>
                <HeaderSidebarToggle className="ms-2" />
            </div>
        </div>

        <div className="page-content-wrapper">
            <div className="container">
                <div className="profile-wrapper-area py-3">
                    <div className="card user-data-card">
                        <div className="card-body">
                            <p className="text-muted mb-3">Liên hệ với Kiosk để được hỗ trợ.</p>
                            <div className="list-group list-group-flush">
                                {contactDetails.map(({ icon, label, value, href }) => (
                                    <div
                                        className="list-group-item px-0 d-flex align-items-center justify-content-between"
                                        key={label}
                                    >
                                        <div className="d-flex align-items-center">
                                            <i className={`mdi ${icon} fs-4 me-3 text-primary`}></i>
                                            <span>{label}</span>
                                        </div>
                                        {href ? (
                                            <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                                                {value}
                                            </a>
                                        ) : (
                                            <span>{value}</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default ContactPage;
